'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
import { HeroBannerBlock } from './hero-banner';
import { getSectionId } from './section-id';
import { getSectionSpacing } from './section-spacing';
interface HeroSliderProps {
  block: Record<string, unknown>;
}
export function HeroSliderBlock(t0) {
  const $ = _c(40);
  const {
    block
  } = t0;
  let t1;
  if ($[0] !== block.slides) {
    t1 = block.slides as Record<string, unknown>[] || [];
    $[0] = block.slides;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const slides = t1;
  const isFirstBlock = block._isFirstBlock === true;
  const autoplay = block.autoplay !== false;
  const autoplaySpeed = block.autoplaySpeed as number || 5000;
  const showDots = block.showDots !== false;
  const showArrows = block.showArrows !== false;
  const sectionSpacing = block.sectionSpacing as string | undefined;
  let t2;
  if ($[2] !== block) {
    t2 = getSectionId(block);
    $[2] = block;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const sectionId = t2;
  const scrollRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [inView, setInView] = useState(true);
  const interactingRef = useRef(false);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = index => {
      const el = scrollRef.current;
      if (!el) {
        return;
      }
      el.scrollTo({
        left: index * el.clientWidth,
        behavior: "smooth"
      });
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const scrollToIndex = t3;
  let t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      const el_0 = scrollRef.current;
      if (!el_0) {
        return;
      }
      let raf = 0;
      const onScroll = () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          if (!el_0.clientWidth) {
            return;
          }
          setActiveIndex(Math.round(el_0.scrollLeft / el_0.clientWidth));
        });
      };
      const start = () => {
        interactingRef.current = true;
      };
      const end = () => {
        interactingRef.current = false;
      };
      el_0.addEventListener("scroll", onScroll, {
        passive: true
      });
      el_0.addEventListener("touchstart", start, {
        passive: true
      });
      el_0.addEventListener("touchend", end, {
        passive: true
      });
      el_0.addEventListener("touchcancel", end, {
        passive: true
      });
      el_0.addEventListener("pointerenter", start);
      el_0.addEventListener("pointerleave", end);
      return () => {
        cancelAnimationFrame(raf);
        el_0.removeEventListener("scroll", onScroll);
        el_0.removeEventListener("touchstart", start);
        el_0.removeEventListener("touchend", end);
        el_0.removeEventListener("touchcancel", end);
        el_0.removeEventListener("pointerenter", start);
        el_0.removeEventListener("pointerleave", end);
      };
    };
    t5 = [];
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      const el_1 = scrollRef.current;
      if (!el_1 || typeof IntersectionObserver === "undefined") {
        return;
      }
      const io = new IntersectionObserver(t8 => {
        const [entry] = t8;
        return setInView(entry.isIntersecting);
      }, {
        threshold: 0.5
      });
      io.observe(el_1);
      return () => io.disconnect();
    };
    t7 = [];
    $[7] = t6;
    $[8] = t7;
  } else {
    t6 = $[7];
    t7 = $[8];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($[9] !== autoplay || $[10] !== autoplaySpeed || $[11] !== inView || $[12] !== slides.length) {
    t8 = () => {
      if (!autoplay || !inView || slides.length < 2) {
        return;
      }
      if (typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        return;
      }
      const id = window.setInterval(() => {
        if (interactingRef.current || document.hidden) {
          return;
        }
        const el_2 = scrollRef.current;
        if (!el_2?.clientWidth) {
          return;
        }
        const current = Math.round(el_2.scrollLeft / el_2.clientWidth);
        scrollToIndex((current + 1) % slides.length);
      }, autoplaySpeed);
      return () => window.clearInterval(id);
    };
    t9 = [autoplay, autoplaySpeed, inView, scrollToIndex, slides.length];
    $[9] = autoplay;
    $[10] = autoplaySpeed;
    $[11] = inView;
    $[12] = slides.length;
    $[13] = t8;
    $[14] = t9;
  } else {
    t8 = $[13];
    t9 = $[14];
  }
  useEffect(t8, t9);
  if (slides.length === 0) {
    return null;
  }
  const t10 = sectionSpacing || "none";
  let t11;
  if ($[15] !== t10) {
    t11 = getSectionSpacing(t10);
    $[15] = t10;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  const t12 = `relative ${t11}`;
  let t13;
  if ($[17] !== activeIndex || $[18] !== showArrows || $[19] !== slides.length) {
    t13 = showArrows && slides.length > 1 && <><button type="button" onClick={() => scrollToIndex(Math.max(activeIndex - 1, 0))} className="absolute left-4 top-1/2 z-20 hidden -translate-y-1/2 rounded-full bg-white/90 px-4 py-2 text-sm font-semibold shadow md:block">Prev</button><button type="button" onClick={() => scrollToIndex(Math.min(activeIndex + 1, slides.length - 1))} className="absolute right-4 top-1/2 z-20 hidden -translate-y-1/2 rounded-full bg-white/90 px-4 py-2 text-sm font-semibold shadow md:block">Next</button></>;
    $[17] = activeIndex;
    $[18] = showArrows;
    $[19] = slides.length;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== isFirstBlock || $[22] !== slides) {
    let t15;
    if ($[24] !== isFirstBlock) {
      t15 = (slide, index_0) => <div key={slide.id as string || index_0} className="min-w-full snap-start"><HeroBannerBlock block={{
          ...slide,
          _nested: true,
          _isFirstBlock: isFirstBlock && index_0 === 0,
          sectionSpacing: "none"
        }} /></div>;
      $[24] = isFirstBlock;
      $[25] = t15;
    } else {
      t15 = $[25];
    }
    t14 = slides.map(t15);
    $[21] = isFirstBlock;
    $[22] = slides;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[26] !== t14) {
    t15 = <div ref={scrollRef} className="flex snap-x snap-mandatory overflow-x-auto overscroll-x-contain scroll-smooth [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">{t14}</div>;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== activeIndex || $[29] !== showDots || $[30] !== slides) {
    t16 = showDots && slides.length > 1 && <div className="absolute bottom-6 left-1/2 z-20 flex -translate-x-1/2 gap-2">{slides.map((slide_0, index_1) => <button key={slide_0.id as string || index_1} type="button" onClick={() => scrollToIndex(index_1)} className={`h-2.5 w-2.5 rounded-full transition-all ${index_1 === activeIndex ? "bg-white scale-110" : "bg-white/50"}`} aria-label={`Go to slide ${index_1 + 1}`} />)}</div>;
    $[28] = activeIndex;
    $[29] = showDots;
    $[30] = slides;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t13 || $[33] !== t15 || $[34] !== t16) {
    t17 = <div className="relative">{t13}{t15}{t16}</div>;
    $[32] = t13;
    $[33] = t15;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== sectionId || $[37] !== t12 || $[38] !== t17) {
    t18 = <section id={sectionId} className={t12}>{t17}</section>;
    $[36] = sectionId;
    $[37] = t12;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  return t18;
}